"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useTagRefocus = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _2 = require(".");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var useTagRefocus = function useTagRefocus(_ref) {
  var stateValue = _ref.stateValue,
      isMulti = _ref.isMulti,
      inputRef = _ref.inputRef;

  var _useState = (0, _react.useState)([]),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      tagDeleteRefs = _useState2[0],
      setTagDeleteRefs = _useState2[1];

  var focusOnInput = function focusOnInput() {
    if (inputRef && inputRef.current) {
      inputRef.current.focus();
    }
  };

  var refocus = function refocus(deletedIndex) {
    (0, _2.resetTagFocus)({
      refs: tagDeleteRefs,
      deletedIndex: deletedIndex,
      onLastTagDeleted: focusOnInput
    });
  };

  var removeTagRef = function removeTagRef(deletedIndex, isSelectDropdownOpen) {
    if (!isSelectDropdownOpen) {
      refocus(deletedIndex);
    }

    setTagDeleteRefs(function (prevRefs) {
      return prevRefs.filter(function (_, i) {
        return i !== deletedIndex;
      });
    });
  };

  (0, _react.useEffect)(function () {
    if (isMulti && Array.isArray(stateValue)) {
      var initialRefs = Array.from({
        length: stateValue.length
      }, function () {
        return /*#__PURE__*/_react.default.createRef();
      });
      setTagDeleteRefs(initialRefs);
    }
  }, [isMulti, stateValue]);
  return {
    tagDeleteRefs: tagDeleteRefs,
    removeTagRef: removeTagRef
  };
};

exports.useTagRefocus = useTagRefocus;